module.exports = __webpack_public_path__ + "img/7-6.ded8c1a5.png";